import image from './remote-control-managed-account.png'

export default ({ alt }: { alt: string }): React.ReactElement => (
  <img width="66px" height="66px" src={image} alt={alt} />
)
